import {
    TASK_EMPLOYEE_LIST,
    TASK_EMPLOYEE_LIST_SUCCESS,
    TASK_EMPLOYEE_LIST_ERROR,
    TASK_EMPLOYEE_ADD,
    TASK_EMPLOYEE_ADD_SUCCESS,
    TASK_EMPLOYEE_ADD_ERROR,
    TASK_EMPLOYEE_UPDATE,
    TASK_EMPLOYEE_UPDATE_SUCCESS,
    TASK_EMPLOYEE_UPDATE_ERROR,
    TASK_EMPLOYEE_MODAL_SET,
    TASK_EMPLOYEE_SELECTED_SET
} from '../actions';

const INIT_STATE = {
    loading: false,
    error: false,
    list: {
        data: []
    },
    add: {
        loading: false,
        id: null
    },
    update: {
        loading: false
    },
    modal: false,
    selected_id_employee: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case TASK_EMPLOYEE_LIST:
            return { ...state, loading: true };
        case TASK_EMPLOYEE_LIST_SUCCESS:
            return { ...state, loading: false, list: { data: action.payload } };
        case TASK_EMPLOYEE_LIST_ERROR:
            return { ...state, loading: false, error: true, list: { data: [] } };
        case TASK_EMPLOYEE_ADD:
            return { ...state, add: { ...state.add, loading: true } };
        case TASK_EMPLOYEE_ADD_SUCCESS:
            return { ...state, add: { loading: false, id: action.payload } };
        case TASK_EMPLOYEE_ADD_ERROR:
            return { ...state, add: { ...state.add, loading: false } };
        case TASK_EMPLOYEE_UPDATE:
            return { ...state, update: { loading: true } };
        case TASK_EMPLOYEE_UPDATE_SUCCESS:
            return { ...state, update: { loading: false } };
        case TASK_EMPLOYEE_UPDATE_ERROR:
            return { ...state, update: { loading: false } };
        case TASK_EMPLOYEE_MODAL_SET:
            return { ...state, modal: action.payload };
        case TASK_EMPLOYEE_SELECTED_SET:
            return { ...state, selected_id_employee: action.payload };
        default:
            return state;
    }
};
